const overrideEmailErrorMessage = (message) => {
  switch (message) {
    case "can't be blank":
      return "Add your email to continue";
    case "is invalid":
      return "Please use the format yourname@example.com";
    case "has already been taken":
      return message;
    case "is in a format that we don't recognize. Please double check for any typos, and try again.":
      return "We don't recognize that email format. Double check for any typos, and try again.";
    default:
      return message;
  }
};
const overridePhoneNumberErrorMessage = (message) => {
  switch (message) {
    case "can't be blank":
      return "Please enter your phone number";
    case "is an invalid number":
      return "Please enter a valid U.S. phone number starting with the area code";
    case "cannot be used to create a new account. Please choose a different number, capable of receiving two-factor authentication calls or text messages.":
      return "Phone number cannot be used to create a new account. Please choose a different number, capable of receiving two-factor authentication calls or text messages.";
    default:
      return message;
  }
};
const convertApiErrorsToFormikMsg = (errors, options) => {
  const errorMessage = {};
  Object.keys(errors.messages).forEach((key) => {
    errorMessage[key] = (options == null ? void 0 : options.overrideErrorMessage) ? options.overrideErrorMessage(errors.messages[key][0]) : errors.messages[key][0];
  });
  if (options == null ? void 0 : options.parentKey) {
    return {
      [options.parentKey]: errorMessage
    };
  }
  return errorMessage;
};
export {
  overrideEmailErrorMessage as a,
  convertApiErrorsToFormikMsg as c,
  overridePhoneNumberErrorMessage as o
};
//# sourceMappingURL=form-helpers-C1M2v4FK.js.map
